import { FC, PropsWithChildren, createContext, useMemo, useState } from "react";

type TemplateContextType = {
  loading: boolean;
  error: Error | undefined;
};

const TemplateContext = createContext<TemplateContextType>({
  loading: false,
  error: undefined,
});

export const TemplateProvider: FC<PropsWithChildren> = ({ children }) => {
  const [loading] = useState<boolean>(false);
  const [error] = useState<Error | undefined>(undefined);

  const contextValue = useMemo(
    () => ({
      loading,
      error,
    }),
    [loading, error],
  );

  return <TemplateContext.Provider value={contextValue}>{children}</TemplateContext.Provider>;
};
